import { and, desc, eq, getTableColumns, isNull, sql } from "drizzle-orm";

import type { WsWorkflowItem } from "@storyboard/web-client";
import { bulkInsert } from "@/db/bulkInsert";
import { db } from "@/db/db";
import { executeBuiltQuery, Tx } from "@/db/drizzleUtils";
import { workflowItem } from "@/db/schema";
import { deduplicateByKeyValue } from "@/models/appSyncFunctions.ts";
import { emptyQuery } from "@/models/emptyQuery.ts";
import { emitTableUpdates } from "@/models/eventing/TableEventManager";
import { logQuery } from "@/models/logQuery.ts";

export async function deleteWsDraft(draftId: string, tx?: Tx) {
  const res = await executeBuiltQuery(db.delete(workflowItem).where(eq(workflowItem.id, draftId)), "deleteWsDraft", tx);
  emitTableUpdates(["workflow_item"]);
  return res;
}

export async function bulkUpsertWorkflowItem(records: WsWorkflowItem[]) {
  if (records.length === 0) return;
  const deduped = deduplicateByKeyValue(records, (item) => item.id);
  await bulkInsert(workflowItem, deduped, {
    onConflict: {
      type: "doUpdate",
      target: [workflowItem.id],
      set: {
        workspaceId: sql`excluded."workspaceId"`,
        contentId: sql`excluded."contentId"`,
        createdAt: sql`excluded."createdAt"`,
        deletedAt: sql`excluded."deletedAt"`,
        displayName: sql`excluded."displayName"`,
      },
    },
  });
  emitTableUpdates(["workflow_item"]);
}

export function workflowItemsSelect({ workspaceId }: { workspaceId?: string }) {
  const query = db
    .selectDistinct({
      ...getTableColumns(workflowItem),
    })
    .from(workflowItem)
    .where(and(eq(workflowItem.workspaceId, workspaceId), isNull(workflowItem.deletedAt)))
    .orderBy(desc(workflowItem.createdAt));

  if (!workspaceId) {
    return emptyQuery as unknown as typeof query;
  }
  logQuery("Workflow Items", query);
  return query;
}
